<script setup lang="ts">
import { usePejer } from '@/Pejer'
import { ArchiveIcon } from 'lucide-vue-next'
import Button from 'pejer/src/components/ui/button/Button.vue'
import { toast } from 'pejer/src/components/ui/toast'
import { PejerTablesList } from 'pejer/src/types/base'
import usePejerMutation from 'pejer/src/usePejerMutation'
import ConfirmationModal from '../other/ConfirmationModal.vue'

const props = defineProps<{
  connectedAccount: PejerTablesList<'connectedAccounts'>
}>()

const pejer = usePejer()
const { mutateAsync } = usePejerMutation(pejer.urls.connectedAccounts.archive, {
  queryKeys: [
    ['connectedAccounts', 'list'],
    ['connectedAccounts', props.connectedAccount.connectedAccountID],
  ],
  onSuccess: () => {
    toast({
      title: 'Kontoen ble arkivert',
    })
  },
})

const archiveAccount = async () => {
  await mutateAsync({
    pathArgs: { id: props.connectedAccount.connectedAccountID },
  })
}
</script>
<template>
  <ConfirmationModal word="arkiver" @confirmed="archiveAccount" title="Arkiver konto">
    <template #description>
      <span> Er du sikker på at du vil arkivere denne kontoen? </span>
    </template>
    <slot>
      <Button variant="outline" class="w-full text-red-500">
        <ArchiveIcon class="w-5 h-5 mr-2" /> Arkiver konto
      </Button>
    </slot>
  </ConfirmationModal>
</template>
